import { Money, PeopleShare } from '@zappyrent/hundop';
import { useTranslation } from 'react-i18next';

import {
  StyledIconWrapper,
  StyledList,
  StyledListItem,
} from './Benefits.styles';
import { StyledWrapper } from './Benefits.styles';
import { StyledParagraph, StyledH3, StyledH2 } from '../UI/Typography';

const Benefits = (): JSX.Element => {
  const { t } = useTranslation(['common']);

  return (
    <StyledWrapper>
      <StyledH2>{t('common:ourBenefits')}</StyledH2>
      <StyledList>
        <StyledListItem>
          <StyledIconWrapper>
            <PeopleShare />
          </StyledIconWrapper>
          <StyledH3>{t('common:ourBenefitsListTitle1')}</StyledH3>
          <StyledParagraph>
            {t('common:ourBenefitsListDescription1')}
          </StyledParagraph>
        </StyledListItem>
        <StyledListItem>
          <StyledIconWrapper>
            <Money />
          </StyledIconWrapper>
          <StyledH3>{t('common:ourBenefitsListTitle2')}</StyledH3>
          <StyledParagraph>
            {t('common:ourBenefitsListDescription2')}
          </StyledParagraph>
        </StyledListItem>
      </StyledList>
    </StyledWrapper>
  );
};

export default Benefits;
